import { render, staticRenderFns } from "./FavoriteTeamsTable.vue?vue&type=template&id=3560b4d6&scoped=true&"
import script from "./FavoriteTeamsTable.vue?vue&type=script&lang=js&"
export * from "./FavoriteTeamsTable.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteTeamsTable.vue?vue&type=style&index=0&id=3560b4d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3560b4d6",
  null
  
)

export default component.exports